module.exports = __webpack_public_path__ + "597cff719002369e6fe173dd377cc8af.svg";